module.exports = __webpack_public_path__ + "headerBar-bf650ed4d9b6dc22e2fe658a1800e17a.png";